<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import  userService from './components/service/UserService'
export default {
  name: 'app',
  data(){
    return {
      isLogin: false,
      excludeLoginCheck: ["/play/wasm", "/play/rtc"],
      userInfo: { //保存用户信息
        nick: null,
        ulevel: null,
        uid: null,
        portrait: null
      }
    }
  },
  created() {
    if (userService.getToken() == null){
      console.log(22222)
      console.log(this.$route.path)
      try {
        if (this.excludeLoginCheck && this.excludeLoginCheck.length > 0) {
          for (let i = 0; i < this.excludeLoginCheck.length; i++) {
            if (this.$route.path.startsWith(this.excludeLoginCheck[i])){
              return;
            }
          }
        }
      }catch (e) {
        console.error(e)
      }
      //如果没有登录状态则跳转到登录页
      if(this.$route.path.indexOf('frame') === -1){
        this.$router.push('/login');
      }
    }
  },

  mounted(){
    //组件开始挂载时获取用户信息
    // this.getUserInfo();
  },
  methods: {
  },
  components: {}
};
</script>

<style>
html,
body,
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  box-sizing: border-box;
  background: linear-gradient(135deg, #e8edf2 0%, #eef1f6 30%, #f5f7fa 60%, #e9eef3 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}
.el-header,
.el-footer {
  height: 44px !important;
  padding: 0 !important;
  color: #333;
  text-align: center;
  line-height: 44px;
}
.el-main {
  background: transparent;
  color: #303133;
  text-align: center;
  padding: 12px !important;
}

/* 美化滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  border-radius: 3px;
  background-color: #f0f2f5;
}
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: #c0c4cc;
  transition: background-color 0.3s;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #909399;
}

/* 表格表头增强 */
.table-header {
  color: #303133;
  font-weight: 600;
}
.el-table th.el-table__cell {
  background-color: #f5f7fa !important;
  color: #303133 !important;
  font-weight: 600 !important;
  border-bottom: 2px solid #e4e7ed !important;
}
.el-table .el-table__body tr:hover > td {
  background-color: #ecf5ff !important;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #fafbfc;
}

/* 表格单元格内部padding */
.el-table td.el-table__cell,
.el-table th.el-table__cell {
  padding: 10px 0;
}

/* el-card 增强 — 匹配 Login 卡片风格 */
.el-card {
  border-radius: 6px !important;
  border: 1px solid #ebeef5 !important;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04), 0 4px 16px rgba(0, 0, 0, 0.04) !important;
  transition: box-shadow 0.3s ease;
}
.el-card:hover {
  box-shadow: 0 2px 14px rgba(64, 158, 255, 0.06), 0 8px 32px rgba(0, 0, 0, 0.07) !important;
}

/* el-card header 样式 */
.el-card__header {
  border-bottom: 1px solid #ebeef5;
  padding: 14px 20px;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}
.el-card__body {
  padding: 20px;
}

/* el-tag 更圆润 */
.el-tag {
  border-radius: 4px !important;
}

/* 分页器间距 */
.el-pagination {
  padding: 12px 0;
}

/* 按钮增强 — 匹配 Login 按钮动效 */
.el-button--primary {
  background: #409EFF;
  border-color: #409EFF;
  transition: all 0.3s ease;
}
.el-button--primary:hover {
  background: #66B1FF;
  border-color: #66B1FF;
  box-shadow: 0 4px 16px rgba(64, 158, 255, 0.35);
  transform: translateY(-1px);
}
.el-button--primary:active {
  background: #3A8EE6;
  border-color: #3A8EE6;
}
.el-button--success:hover {
  box-shadow: 0 4px 12px rgba(103, 194, 58, 0.35);
  transform: translateY(-1px);
}
.el-button--danger:hover {
  box-shadow: 0 4px 12px rgba(245, 108, 108, 0.35);
  transform: translateY(-1px);
}

/* el-input / el-select 聚焦态匹配 Login */
.el-input__inner:focus,
.el-select .el-input.is-focus .el-input__inner {
  border-color: #409EFF !important;
}

/* el-dialog 增强 */
.el-dialog {
  border-radius: 6px !important;
}
.el-dialog__header {
  padding: 18px 24px 14px;
  border-bottom: 1px solid #ebeef5;
}
.el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
.el-dialog__body {
  padding: 24px;
}

/* dialog 内部表单统一 */
.el-dialog__body .el-form-item__label {
  color: #606266;
  font-weight: 500;
}
.el-dialog__body .el-form-item {
  margin-bottom: 18px;
}

/* el-descriptions 增强 */
.el-descriptions {
  margin-bottom: 20px;
}
.el-descriptions__title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}
.el-descriptions__body .el-descriptions__table {
  border-radius: 6px;
}
.el-descriptions .el-descriptions__label {
  color: #606266;
  font-weight: 500;
}

/* 删除按钮统一色 */
.delete-btn {
  color: #f56c6c !important;
}

/* 视频列表通用样式 */
.videoList {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.video-item {
  position: relative;
  width: 15rem;
  height: 10rem;
  margin-right: 1rem;
  background-color: #000;
}
.video-item-img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
  height: 100%;
}
.video-item-img::after {
  content: "";
  display: inline-block;
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 3rem;
  height: 3rem;
  background-image: url("./assets/loading.png");
  background-size: cover;
  background-color: #000;
}
.video-item-title {
  position: absolute;
  bottom: 0;
  color: #000;
  background-color: #fff;
  line-height: 1.5rem;
  padding: 0.3rem;
  width: 14.4rem;
}

/* 下载链接（按钮内） */
.btn-download-link {
  color: #fff;
  text-align: center;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue